import { useSession } from './hooks/useSession';
import { useSocket } from './hooks/useSocket';
import SetupPage from './pages/SetupPage';
import SessionPage from './pages/SessionPage';
import InstallPrompt from './components/common/InstallPrompt';

function App() {
  const { session } = useSession();
  const { isConnected } = useSocket();

  return (
    <div className="min-h-screen bg-gray-900 safe-area-top safe-area-bottom">
      {!isConnected && (
        <div className="fixed top-0 left-0 right-0 bg-red-600 text-white text-center py-2 z-50">
          Připojování k serveru...
        </div>
      )}

      {session ? <SessionPage /> : <SetupPage />}

      <InstallPrompt />
    </div>
  );
}

export default App;
